import Vue from 'vue';
import Vuex from 'vuex';
import Vuetify from 'vuetify/dist/vuetify.min';
import VueI18Next from '@panter/vue-i18next';
import moment from 'moment';
import 'moment-timezone';
import 'vuetify/dist/vuetify.min.css';
import RcApp from '@/views/base/RcApp.vue';
import RcContentCard from '@/components/RcContentCard.vue';
import rcDebounce from '@/mixins/rcDebounce';
import i18next from 'i18next';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import RcNavigationTree from '@/components/RcNavigationTree.vue';
import XHR from 'i18next-xhr-backend';
import store from './store';
import router from './router';

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(Vuetify, {
  theme: {
    primary: '#015a94',
  },
});
Vue.use(VueI18Next);

Object.defineProperty(Vue.prototype, '$moment', { value: moment });
Vue.mixin(rcDebounce);

export const defaultLanguage = 'fr';
export const languages = [
  {
    code: 'fr',
    name: 'Français',
    dir: 'ltr',
  },
  {
    code: 'en',
    name: 'English',
    dir: 'ltr',
  },
];

i18next.use(Backend).init({
  lng: defaultLanguage,
  defaultNS: 'navigation',
  backend: {
    backends: [LocalStorageBackend, XHR],
    backendOptions: [
      {
        prefix: 'i18next_res_',
        expirationTime: 7 * 24 * 60 * 60 * 1000,
      },
      {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
    ],
  },
});

Vue.component('rc-content-card', RcContentCard);
Vue.component('rc-navigation-tree', RcNavigationTree);

Vue.directive('click-outside', {
  bind: function(el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
      if (compName) { warn += `Found in component '${compName}'` }
      
      console.warn(warn)
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = handler

    // add Event Listeners
    document.addEventListener('click', handler)
  },
  
  unbind: function(el, binding) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__)
    el.__vueClickOutside__ = null

  }
});

Vue.directive('rc-loader', {
  bind(el, binding) {
    el.classList.add('load-wrapper');
    const pendingDiv = document.createElement('div');
    pendingDiv.classList.add('isPending');
    pendingDiv.style['--topOffset'] = `calc(50% + ${el.scrollTop}px)`;
    if (binding.value) {
      pendingDiv.style.setProperty('--topOffset', `calc(50% + ${el.scrollTop}px)`);
      el.classList.add('load-content');
    } else {
      el.classList.remove('load-content');
    }
    el.append(pendingDiv);
  },
  componentUpdated(el, binding) {
    if (binding.value) {
      const pendingDiv = el.querySelectorAll(':scope > .isPending');
      pendingDiv[0].style.setProperty('--topOffset', `calc(50% + ${el.scrollTop}px)`);
      el.classList.add('load-content');
    } else {
      el.classList.remove('load-content');
    }
  },
});

const i18n = new VueI18Next(i18next);

new Vue({
  i18n,
  store,
  router,
  render: h => h(RcApp),
}).$mount('#app');
